// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

export class Polyline {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):Polyline {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPolyline(bb:flatbuffers.ByteBuffer, obj?:Polyline):Polyline {
  return (obj || new Polyline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPolyline(bb:flatbuffers.ByteBuffer, obj?:Polyline):Polyline {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Polyline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

name():string|null
name(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
name(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

descriptor():string|null
descriptor(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
descriptor(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

isClosed():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startPolyline(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addName(builder:flatbuffers.Builder, nameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, nameOffset, 0);
}

static addDescriptor(builder:flatbuffers.Builder, descriptorOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, descriptorOffset, 0);
}

static addIsClosed(builder:flatbuffers.Builder, isClosed:boolean) {
  builder.addFieldInt8(2, +isClosed, +false);
}

static endPolyline(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPolyline(builder:flatbuffers.Builder, nameOffset:flatbuffers.Offset, descriptorOffset:flatbuffers.Offset, isClosed:boolean):flatbuffers.Offset {
  Polyline.startPolyline(builder);
  Polyline.addName(builder, nameOffset);
  Polyline.addDescriptor(builder, descriptorOffset);
  Polyline.addIsClosed(builder, isClosed);
  return Polyline.endPolyline(builder);
}
}
